<script>

    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()

    export let label = null
    export let text = ''
    export let value = ''

    export let required = true
    export let size = ''

    export let options = [] // {value, text}

    const uid = `select-${Math.random().toString(36).slice(2, 9)}`

    function onChange() {
        dispatch('select', value)
    }

</script>

<!-- svelte-ignore a11y-no-onchange -->

<div class="field">
    {#if label}
        <label for={uid} class="label">{ label }</label>
    {/if}
    <div class="control">
        <div class="select is-fullwidth is-{size}">
            <select id={uid} bind:value={value} on:change={onChange} on:change { required } >
                <option value="">{ text || 'Selecciona una opción'}</option>
                {#each options as option}
                    <option value="{ option.value }">{ option.text }</option>
                {/each}
            </select>
        </div>
    </div>
</div>
